import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/link/$parentId/payments')({
  component: PaymentsLayout,
})

function PaymentsLayout() {
  return <Outlet />
}
